import styled from 'styled-components';
import { IconButton } from 'ui/button';
import { Modal } from 'ui/modal';
import { spacing, colors, body1 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const GlobalToggleContainer = styled.div`
  ${body1};
  align-items: flex-end;
  display: flex;
  gap: ${spacing.half};
`;

export const InputListsContainer = styled.div<{ columns: number }>`
  display: grid;
  gap: ${spacing.half};
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
`;

export const OrgContainer = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
  > *:first-child {
    flex: 1;
  }
`;

export const SliderContainer = styled.div`
  align-items: baseline;
  display: flex;
  gap: ${spacing.base};
  > * {
    flex: 1 0 auto;
  }
  .rc-slider {
    /** overriding rc-slider default class styles */
    margin-top: 0;
    flex: 0 1 65%;
  }
`;

export const StyledModal = styled(Modal)`
  min-height: ${pxToRem(850)};
`;

export const WarningText = styled.span`
  color: ${colors.warning100};
`;

export const DescriptionContentContainer = styled.div`
  align-items: center;
  background: none;
  display: flex;
  width: ${pxToRem(800)};
`;

export const DescriptionText = styled.span`
  ${body1};
  font-style: italic;
`;

export const StyledIconButton = styled(IconButton)`
  height: ${pxToRem(24)};
  :focus:before {
    border: none;
  }
`;
